<template>
    <div class="batch-upload">
      <el-upload action="" :on-preview="handlePreview" :on-remove="handleRemove"
                 :before-remove="beforeRemove" :on-success="handleSuccess" multiple :show-file-list="false" :before-upload="beforeUpload"
                 :on-exceed="handleExceed" :file-list="fileList" :http-request="excelUploadRequest">
        <el-button class="search-btn btn-blue">{{ $t('createOrder.createOrder9') }}</el-button>
      </el-upload>
    </div>
</template>
<script>
export default {
    name: "BatchUpload",
    data () {
        return {
            fileList: [],
            exportNum: 1,
            messageErrorList: []
        };
    },
    methods: {
        // 点击文件列表中已上传的文件时的钩子
        handlePreview() {
            return
        },
        // 文件列表移除文件时的钩子
        handleRemove() {
            return
        },
        // 删除文件之前的钩子
        beforeRemove (file) {
            // return this.$confirm(`${this.$t('orderList.orderList107')} ${file.name}?`);
        },
        // 文件上传成功时的钩子
        handleSuccess (response, file, fileList) {
            this.fileList = []
            // this.$message.success(
            //     `${this.$t('createOrder.createOrder73')},${this.$t('createOrder.createOrder94')} ${fileList.length} ${this.$t('createOrder.createOrder93')}`
            // );
        },

        // 文件超出个数限制时的钩子
        handleExceed (files, fileList) {
            this.$message.warning(
                `${this.$t('createOrder.createOrder91')},${this.$t('createOrder.createOrder92')} ${files.length} ${this.$t('createOrder.createOrder93')},${this.$t('createOrder.createOrder94')} ${files.length + fileList.length
                } ${this.$t('createOrder.createOrder93')}`
            );
        },
        beforeUpload (file) {
            const isLt20M = file.size / 1024 / 1024 <= 20
            if (!isLt20M) {
                this.$message.error(this.$t('createOrder.createOrder97'))
                return false
            }
            return true
        },
        // 覆盖默认的上传行为
        async excelUploadRequest (file) {
            this.exportNum += 1
            let formdata = new FormData();
            formdata.append('file', file.file);
            const { data: res } = await this.$http.post('shopping/vehicle/importAction', formdata);
            if(res.code === 200) this.$emit('success', res.data)
            else {
              // let newMessage = res?.message?.replace(/\n/g, "<br/>");
              this.messageErrorList = res?.message.split(`\n`)
              if(this.messageErrorList && this.messageErrorList.length > 0) {
                this.$modalDialog(() => import('./ErrorList.vue'), {
                  messageErrorList: this.messageErrorList,
                }).then(
                    () => {
                    },
                    () => {
                    }
                )
              }
              console.log(this.messageErrorList,9999)
              // this.$alert(newMessage, this.$t('createOrder.createOrder9'), {
              //   dangerouslyUseHTMLString: true,
              //   showConfirmButton: false,
              //   showCancelButton: false,
              //   customClass: 'batch-set-css-box',
              // });
              // this.$message({
              //   message: newMessage || res.message,
              //   dangerouslyUseHTMLString: true,
              //   type: "error",
              // });
            }
        },
    }
}
</script>
<style lang="less" scoped>

</style>
